module.exports = __webpack_public_path__ + "img/481.319c8663.jpg";